// ── RTS COMMAND SYSTEM ──
// All player actions go through commands. Each command carries cmd.side.
// Host executes locally. Guest sends to host. One unified executor.

const rtsCommandQueue = [];

function issueCommand(cmd){
  cmd.tick = S.frame;
  if(window._mpMultiplayer && mpConnected){
    // Lockstep: buffer command for future turn (both clients)
    lsBufferCommand(cmd);
  } else {
    // Singleplayer: execute immediately
    cmd.side = 'player';
    rtsCommandQueue.push(cmd);
  }
}

function processCommands(){
  while(rtsCommandQueue.length > 0){
    executeCommand(rtsCommandQueue.shift());
  }
}

function executeCommand(cmd){
  const side = cmd.side || 'player';
  const faction = side==='player' ? S.playerFaction : S.enemyFaction;
  const cfg = FACTION_CFG[faction];
  const elite2FnMap = { makeWizard, makeNecromancer, makeTank };
  const aerial2FnMap = { makeWarship, makeLightFighter, makeDestroyer };
  const warrior2FnMap = { makeWarbot, makeLegionnaireSquad };
  const warrior2TimeMap = { makeWarbot:BUILD_TIMES.warbot, makeLegionnaireSquad:BUILD_TIMES.legionnairesquad };
  const getBuildTypeFromEntity = (ent)=>{
    if(!ent) return 'structure';
    if(ent.type==='base') return 'base';
    if(ent.type==='cannon') return 'cannon';
    if(ent.isBarracks) return 'barracks';
    if(ent.isAerialHangar) return 'aerial';
    if(ent.isOilRig) return 'oilrig';
    if(ent.isResearchLab) return 'researchlab';
    if(ent.isCouncilOfLight) return 'councillight';
    if(ent.isCouncilOfDarkness) return 'councildark';
    return 'structure';
  };

  switch(cmd.type){

    case 'deploy_dark_ship': {
      const temple=S.entities.find(e=>e.id===cmd.buildingId);
      const goldCost=cfg.darkShipGoldCost||0;
      const essenceCost=cfg.darkShipOilCost||0;
      const shipOrVanthelAlive=S.entities.some(e=>e.side===side && (e.subtype==='darkwarriorship'||e.subtype==='vanthel'));
      if(!temple || temple.type!=='base' || temple.side!==side || faction!=='shadow' ||
          temple.underConstruction || (temple.darkShipCooldown||0)>S.frame || shipOrVanthelAlive ||
          !Number.isFinite(cmd.x) || !Number.isFinite(cmd.y) ||
          (S.gold[side]||0)<goldCost || (S.oil[side]||0)<essenceCost) break;
      S.gold[side]-=goldCost;
      S.oil[side]-=essenceCost;
      temple.darkShipCooldown=S.frame+3600;
      S.entities.push(makeDarkWarriorShip(side, faction, cmd.x, cmd.y));
      for(let i=0;i<18;i++) S.particles.push({
        x:cmd.x+(rtsRand()-.5)*55,y:cmd.y+(rtsRand()-.5)*55,
        vx:(rtsRand()-.5)*1.5,vy:-1-rtsRand()*2,life:35+rtsRand()*20,
        color:i%2?'#8800cc':'#9922ff',size:2+rtsRand()*3,
      });
      updateRtsHUD();
      if(side==='player') rtsSetLog("The Dark Warrior's Ship descends, carrying Vanthel!");
      break;
    }

    case 'train_unit': {
      const building = S.entities.find(e=>e.id===cmd.buildingId);
      if(!building || building.underConstruction) break;
      if(building.side !== side) break; // can't train from enemy building
      const aerialFnMap = { makeStarFighter, makeSkyAttacker };
      const costMap = { worker:cfg.workerCost, warrior:cfg.warriorCost, warrior2:cfg.warrior2Cost, prism:cfg.prismCost, arkship:cfg.arkshipCost, elite:cfg.eliteCost, elite2:cfg.elite2Cost, aerial:cfg.aerialUnitCost, aerial2:cfg.aerial2Cost, gongui:cfg.gonguiCost, capitalship:cfg.capitalShipCost };
      const cost = costMap[cmd.unitType] || 0;
      if(cmd.unitType==='prism' && faction==='prism'){
        if(building.type!=='base') break;
        const prismExists=S.entities.some(e=>e.side===side && e.faction==='prism' && e.subtype==='prism');
        const prismQueued=S.entities.some(e=>e.side===side && e.queue?.some(q=>q.unitType==='prism' || q.label===cfg.prismLabel));
        if(prismExists || prismQueued) break;
      }
      if(cmd.unitType==='gongui' && faction==='roboto'){
        if(building.type!=='base') break;
        const gonguiExists=S.entities.some(e=>e.side===side && e.faction==='roboto' && e.subtype==='gongui');
        const gonguiQueued=S.entities.some(e=>e.side===side && e.queue?.some(q=>q.unitType==='gongui' || q.label===cfg.gonguiLabel));
        const gonguiBoarded=S.entities.some(e=>e.side===side && e.faction==='roboto' && e.subtype==='capitalship' && e.passenger);
        if(gonguiExists || gonguiQueued || gonguiBoarded) break;
      }
      if(cmd.unitType==='capitalship' && faction==='roboto'){
        if(!building.isAerialHangar) break;
        const shipExists=S.entities.some(e=>e.side===side && e.faction==='roboto' && e.subtype==='capitalship');
        const shipQueued=S.entities.some(e=>e.side===side && e.queue?.some(q=>q.unitType==='capitalship' || q.label===cfg.capitalShipLabel));
        if(shipExists || shipQueued) break;
      }
      if(cmd.unitType==='arkship'){
        // The Arkship is unique to Prism, must be trained at the Temple, and
        // requires an existing Prism unit — she's drawn inside when it completes.
        if(faction!=='prism' || building.type!=='base') break;
        const prismAvailable=S.entities.some(e=>e.side===side && e.faction==='prism' && e.subtype==='prism');
        if(!prismAvailable) break;
        const arkshipExists=S.entities.some(e=>e.side===side && e.faction==='prism' && e.subtype==='arkship');
        const arkshipQueued=S.entities.some(e=>e.side===side && e.queue?.some(q=>q.unitType==='arkship' || q.label===cfg.arkshipLabel));
        if(arkshipExists || arkshipQueued) break;
      }
      if(S.gold[side] < cost) break;
      // second resource costs (oil / essence / light)
      const oilCost = cmd.unitType==='elite2' ? (cfg.tankOilCost||cfg.elite2OilCost||0)
                    : cmd.unitType==='aerial'  ? (cfg.aerialOilCost||0)
                    : cmd.unitType==='aerial2' ? (cfg.aerial2OilCost||0)
                    : cmd.unitType==='prism' ? (cfg.prismOilCost||0)
                    : cmd.unitType==='gongui' ? (cfg.gonguiOilCost||0)
                    : cmd.unitType==='capitalship' ? (cfg.capitalShipOilCost||0)
                    : cmd.unitType==='arkship' ? (cfg.arkshipOilCost||0)
                    : cmd.unitType==='elite'   ? (cfg.eliteOilCost||0)
                    : cmd.unitType==='warrior2' ? (cfg.warrior2OilCost||0) : 0;
      if(oilCost > 0 && (S.oil[side]||0) < oilCost) break;
      if((cmd.unitType==='warrior2'||cmd.unitType==='elite2'||cmd.unitType==='aerial2') && cfg.researchLabLabel){
        if(!S.research[side]) break; // Warbot/Tank/Warship require completed research
      }
      if(cmd.unitType==='warrior2' && cfg.councilOfLightLabel){
        const hasCouncilLight = S.entities.some(e=>e.side===side && e.isCouncilOfLight && !e.underConstruction);
        if(!hasCouncilLight) break;
      }
      if((cmd.unitType==='elite2'||cmd.unitType==='aerial2') && cfg.councilOfDarknessLabel){
        const hasCouncilDark = S.entities.some(e=>e.side===side && e.isCouncilOfDarkness && !e.underConstruction);
        if(!hasCouncilDark) break;
      }

      const aerial2TimeMap = { makeWarship:BUILD_TIMES.warship, makeLightFighter:BUILD_TIMES.lightfighter, makeDestroyer:BUILD_TIMES.destroyer };
      const timeMap = { worker:BUILD_TIMES.worker, warrior:BUILD_TIMES.warrior, warrior2:warrior2TimeMap[cfg.warrior2Fn], prism:BUILD_TIMES.elite, arkship:BUILD_TIMES.arkship, elite:BUILD_TIMES.elite, elite2:BUILD_TIMES.elite2,
        aerial:BUILD_TIMES[cfg.aerialFn==='makeSkyAttacker'?'skyattacker':'starfighter'],
        aerial2:aerial2TimeMap[cfg.aerial2Fn], gongui:BUILD_TIMES.gongui, capitalship:BUILD_TIMES.capitalship };
      const time = timeMap[cmd.unitType] || BUILD_TIMES.worker;

      const fnMap = {
        worker:  ()=>makeWorker(side, faction, building.x, building.y),
        warrior: ()=>makeWarrior(side, faction, building.x, building.y),
        warrior2:()=>warrior2FnMap[cfg.warrior2Fn](side, faction, building.x, building.y),
        prism:()=>makePrism(side, faction, building.x, building.y),
        arkship: ()=>{
          // "Takes" the Prism unit: she's removed from the field and the
          // Arkship appears where she stood (falls back to the Temple if
          // she died mid-build).
          const prism=S.entities.find(e=>e.side===side && e.faction==='prism' && e.subtype==='prism');
          if(prism){
            const idx=S.entities.indexOf(prism);
            if(idx!==-1) S.entities.splice(idx,1);
          }
          const ark=makeArkship(side, faction, building.x, building.y);
          if(prism){ ark.x=prism.x; ark.y=prism.y; }
          return ark;
        },
        elite:   ()=>makeElite(side, faction, building.x, building.y),
        elite2:  ()=>elite2FnMap[cfg.elite2Fn](side, faction, building.x, building.y),
        aerial:  ()=>aerialFnMap[cfg.aerialFn](side, faction, building.x, building.y),
        aerial2: ()=>aerial2FnMap[cfg.aerial2Fn](side, faction, building.x, building.y),
        gongui:  ()=>makeGongui(side, faction, building.x, building.y),
        capitalship:()=>makeCapitalShip(side, faction, building.x, building.y),
      };

      const fn = fnMap[cmd.unitType];
      if(!fn || (cmd.unitType==='warrior2' && !cfg.warrior2Fn)) break;
      const label = cmd.unitType==='worker' ? cfg.workerLabel
        : cmd.unitType==='warrior' ? cfg.warriorLabel
        : cmd.unitType==='warrior2' ? cfg.warrior2Label
        : cmd.unitType==='prism' ? cfg.prismLabel
        : cmd.unitType==='gongui' ? cfg.gonguiLabel
        : cmd.unitType==='capitalship' ? cfg.capitalShipLabel
        : cmd.unitType==='arkship' ? cfg.arkshipLabel
        : cmd.unitType==='elite' ? cfg.eliteLabel
        : cmd.unitType==='aerial' ? cfg.aerialUnitLabel
        : cmd.unitType==='aerial2' ? cfg.aerial2Label
        : cfg.elite2Label;

      if(!queueUnit(building, label, time, fn, cmd.unitType)) break;
      S.gold[side] -= cost;
      if(oilCost>0) S.oil[side]=Math.max(0,(S.oil[side]||0)-oilCost);
      updateRtsHUD();
      rtsSetLog(`${label} queued (${building.queue.length}/${QUEUE_MAX})`);
      break;
    }

    case 'start_research': {
      if(!cfg.researchLabLabel || S.research[side]) break;
      const lab = S.entities.find(e=>e.id===cmd.buildingId);
      if(!lab || lab.side!==side || !lab.isResearchLab || lab.underConstruction) break;
      const alreadyResearching = S.entities.some(e=>e.side===side && e.isResearchLab && e.queue?.some(q=>q.unitType==='research'));
      if(alreadyResearching) break;
      const cost = cfg.researchCost||0;
      if(S.gold[side] < cost) break;
      const label = cfg.researchLabel||'RESEARCH';
      if(!queueUnit(lab, label, BUILD_TIMES.research, ()=>{ S.research[side]=true; return []; }, 'research')) break;
      S.gold[side] -= cost;
      updateRtsHUD();
      rtsSetLog(`${label} started at the ${cfg.researchLabLabel}!`);
      break;
    }

    case 'build_structure': {
      if(cmd.cost) S.gold[side] -= cmd.cost;
      if(cmd.oilCost) S.oil[side] = Math.max(0, (S.oil[side]||0) - cmd.oilCost);
      const worker = S.entities.find(e=>e.id===cmd.workerId);
      if(!worker) break;
      worker.buildTarget = { x:cmd.x, y:cmd.y, buildType:cmd.buildType, ghost:null };
      worker.state = 'building';
      break;
    }

    case 'move_units': {
      for(const id of cmd.unitIds){
        const unit = S.entities.find(e=>e.id===id);
        if(!unit || unit.side!==side) continue;
        const idx = cmd.unitIds.indexOf(id);
        const spread = idx * 20 - (cmd.unitIds.length * 10);
        unit.moveTarget = { x:cmd.x + spread, y:cmd.y };
        unit.attackMoveTarget = null;
        unit.forcedTarget = null;
        if(unit.type==='worker'){
          unit.assignedTask = null;
          unit.assignedTargetId = null;
        }
        unit.state = unit.type==='warrior' ? 'march' : 'moving';
      }
      break;
    }

    case 'assign_worker_task': {
      const target = S.entities.find(e=>e.id===cmd.targetId);
      if(!target || target.side!==side) break;
      for(const workerId of cmd.workerIds||[]){
        const worker = S.entities.find(e=>e.id===workerId);
        if(!worker || worker.side!==side || worker.type!=='worker') continue;
        worker.moveTarget = null;
        if(cmd.task==='build'){
          if(!target.underConstruction) continue;
          worker.assignedTask = null;
          worker.assignedTargetId = null;
          worker.target = null;
          worker.buildTarget = {
            x:target.x,
            y:target.y,
            buildType:getBuildTypeFromEntity(target),
            ghost:target,
          };
          worker.state = 'building';
        } else if(cmd.task==='gather_oil'){
          if(!target.isOilRig || target.underConstruction) continue;
          worker.buildTarget = null;
          worker.target = target;
          worker.assignedTask = 'gather_oil';
          worker.assignedTargetId = target.id;
          worker.state = 'moving';
          worker.mineTimer = 0;
        }
      }
      break;
    }

    case 'attack_target': {
      for(const id of cmd.unitIds){
        const unit = S.entities.find(e=>e.id===id);
        if(!unit || unit.side!==side || unit.type!=='warrior') continue;
        const target = S.entities.find(e=>e.id===cmd.targetId);
        if(!target) continue;
        unit.forcedTarget = target;
        unit.moveTarget = null;
        unit.attackMoveTarget = null;
        unit.state = 'march';
      }
      break;
    }


    case 'attack_move': {
      for(const id of cmd.unitIds){
        const unit = S.entities.find(e=>e.id===id);
        if(!unit || unit.side!==side || unit.type!=='warrior') continue;
        const idx = cmd.unitIds.indexOf(id);
        const spread = idx * 20 - (cmd.unitIds.length * 10);
        unit.attackMoveTarget = { x:cmd.x + spread, y:cmd.y };
        unit.moveTarget = null;
        unit.forcedTarget = null;
        unit.target = null;
        unit.state = 'march';
      }
      break;
    }

    case 'start_duel': {
      const s1=S.entities.find(e=>e.id===cmd.swordsmanId);
      if(!s1||s1.side!==side||s1.subtype||s1.state==='duel'||s1.type!=='warrior') break;
      let nearest=null, nearestDist=Infinity;
      for(const e of S.entities){
        if(e===s1||e.side!==side||e.type!=='warrior'||e.faction!==s1.faction||e.subtype||e.state==='duel') continue;
        const d=_dist(e.x-s1.x,e.y-s1.y);
        if(d<nearestDist){ nearestDist=d; nearest=e; }
      }
      const pairLabels={shadow:'Swordsmen',roboto:'GunBots',prism:'Witches'};
      const needLabel={shadow:'Swordsman',roboto:'GunBot',prism:'Witch'};
      const label=pairLabels[s1.faction]||'Warriors';
      if(!nearest){ if(side==='player') rtsSetLog(`Need another ${needLabel[s1.faction]||'warrior'} to start a duel!`); break; }
      const s1Wins = Math.random() < 0.5;
      s1.state='duel'; s1.duelOpponentId=nearest.id; s1.duelAttacker=s1Wins;
      nearest.state='duel'; nearest.duelOpponentId=s1.id; nearest.duelAttacker=!s1Wins;
      if(side==='player') rtsSetLog(`Two ${label} enter the duel ring...`);
      break;
    }

    case 'toggle_weapon': {
      const unit=S.entities.find(e=>e.id===cmd.unitId);
      if(!unit||unit.side!==side||!['bloodhound','legionnaire'].includes(unit.subtype)) break;
      unit.bowMode=!unit.bowMode;
      if(unit.subtype==='bloodhound'){
        if(unit.bowMode){ unit.ranged=true; unit.range=260; unit.speed=0.9; unit.fireRate=38; unit.damage=28; }
        else            { unit.ranged=false; unit.range=50;  unit.speed=3.2; unit.fireRate=22; unit.damage=35; }
      } else {
        if(unit.bowMode){ unit.ranged=true; unit.range=210; unit.speed=0.8; unit.fireRate=48; unit.damage=10; }
        else            { unit.ranged=false; unit.range=50;  unit.speed=1.0; unit.fireRate=0;  unit.damage=14; }
      }
      unit.attackTimer=0;
      if(side==='player'){
        const label=unit.subtype==='bloodhound'?'Bloodhound':'Legionnaire';
        rtsSetLog(`${label} switched to ${unit.bowMode?'bow':'sword'} mode!`);
      }
      break;
    }

    case 'toggle_warship_attack_mode': {
      const unit=S.entities.find(e=>e.id===cmd.unitId);
      if(!unit||unit.side!==side||unit.subtype!=='warship') break;
      unit.attackMode=unit.attackMode==='single'?'multiple':'single';
      unit.fireRate=unit.attackMode==='single'?unit.singleFireRate:unit.multipleFireRate;
      unit.attackTimer=0;
      if(side==='player'){
        rtsSetLog(`Warship switched to ${unit.attackMode} attack mode!`);
      }
      break;
    }

    case 'board_gongui': {
      const ship=S.entities.find(e=>e.id===cmd.unitId);
      if(!ship||ship.side!==side||ship.subtype!=='capitalship'||ship.passenger) break;
      let best=null, bestDist=180;
      for(const e of S.entities){
        if(e.side!==side||e.subtype!=='gongui') continue;
        const d=_dist(e.x-ship.x,e.y-ship.y);
        if(d<bestDist){ bestDist=d; best=e; }
      }
      if(!best){ if(side==='player') rtsSetLog('No Gongui nearby to board.'); break; }
      ship.passenger={hp:best.hp,maxHp:best.maxHp};
      S.entities.splice(S.entities.indexOf(best),1);
      if(side==='player') rtsSetLog('Gongui boards the Capital Ship!');
      break;
    }

    case 'deploy_gongui': {
      const ship=S.entities.find(e=>e.id===cmd.unitId);
      if(!ship||ship.side!==side||ship.subtype!=='capitalship'||!ship.passenger||!ship.landed) break;
      const gongui=makeGongui(side, faction, ship.x, ship.y);
      gongui.hp=ship.passenger.hp;
      gongui.maxHp=ship.passenger.maxHp;
      gongui.x=ship.x; gongui.y=ship.y+40;
      S.entities.push(gongui);
      ship.passenger=null;
      if(side==='player') rtsSetLog('Gongui deploys from the Capital Ship!');
      break;
    }

    case 'toggle_capitalship_landed': {
      const ship=S.entities.find(e=>e.id===cmd.unitId);
      if(!ship||ship.side!==side||ship.subtype!=='capitalship') break;
      ship.landed=!ship.landed;
      ship.aerial=!ship.landed;
      ship.attackTimer=0;
      if(side==='player') rtsSetLog(ship.landed?'Capital Ship touches down.':'Capital Ship takes off.');
      break;
    }

    case 'toggle_arkship_mode': {
      const unit=S.entities.find(e=>e.id===cmd.unitId);
      if(!unit||unit.side!==side||unit.subtype!=='arkship') break;
      unit.arkMode=unit.arkMode==='attacking'?'phasing':'attacking';
      unit.attackTimer=0;
      unit.beamTarget=null; unit.beamTarget2=null;
      if(unit.arkMode==='phasing'){
        deployArkshipCrew(unit);
      } else if(side==='player'){
        rtsSetLog('Arkship switched to attacking mode — twin beams online!');
      }
      break;
    }

    case 'attack_all': {
      let count = 0;
      for(const e of S.entities){
        if(e.type==='warrior' && e.side===side && e.state==='idle'){
          e.state = 'march';
          count++;
        }
      }
      rtsSetLog(count > 0 ? `${count} warriors advancing!` : 'No idle warriors to command.');
      break;
    }
  }
}

//# sourceMappingURL=commands.js.map
